/*
  ToDO: Temporal implementation, should be replaced by the dynamic mapping
  from the CMS in the shape of: field, value_current, value_override
*/

import { InventoryField } from '@lamesarv-sdk/types';

export enum InventoryType {
  new = 'New',
  used = 'Used',
}

export enum MessageFavoritesType {
  favoriteSelectInventory = 'favoriteSelectInventory',
  favoriteUnselectInventory = 'favoriteUnselectInventory',
}

export interface IMessageFavorites {
  type: MessageFavoritesType;
  id?: string;
  quantity?: number;
}

/*
  Fee-inclusive price computed by the importer (dbo.TsGetAdvertisedPrice).
  Not in @lamesarv-sdk/types yet, so the Typesense field names live here.
*/
export enum AdvertisedPriceField {
  price = 'advertisedPrice',
  status = 'advertisedPriceStatus',
}

export enum AdvertisedPriceStatus {
  ok = 'OK',
  crossedOut = 'CROSSED_OUT',
  noFeeRow = 'NO_FEE_ROW',
  noPrice = 'NO_PRICE',
}

export interface IAdvertisedPriceFields {
  [AdvertisedPriceField.price]?: number | null;
  [AdvertisedPriceField.status]?: AdvertisedPriceStatus | null;
}

export type BaseFilters = Partial<Record<InventoryField, string[]>>;

export enum FilterSection {
  PROMOTIONS = 'Promotions',
  CONDITION = 'Condition',
  RV_TYPE = 'RV Type',
  MAKE = 'Make',
  MODEL = 'Model',
  FLOOR_PLAN = 'Floor Plan',
  LENGTH = 'Length',
  LOCATION = 'Location',
  PRICE = 'Price',
  FEATURES = 'Features',
  FUEL_TYPE = 'Fuel Type',
  SLEEPS = 'Sleeps',
  YEAR = 'Year',
  SLIDEOUTS = 'Slideouts',
}

export enum SortBy {
  RECOMMENDED = 'Recommended',
  PRICE_LOW_TO_HIGH = 'Price: Low to High',
  PRICE_HIGH_TO_LOW = 'Price: High to Low',
  NEWEST = 'Newest',
  OLDEST = 'Oldest',
}

export enum FilterPromotion {
  FLASH_SALE = 'Flash Sale',
  DAILY_DEAL = 'Daily Deal',
}

export const FilterPromotionInventoryField: Record<FilterPromotion, InventoryField> = {
  [FilterPromotion.FLASH_SALE]: InventoryField.isFlashSale,
  [FilterPromotion.DAILY_DEAL]: InventoryField.isDailyDeal,
};

export interface RangeFilterValue {
  min: number;
  max: number;
}

export type FilterValue = string[] | RangeFilterValue;

export type Filters = Partial<Record<FilterSection, FilterValue>>;

export interface BaseTagFilterItem {
  name: string;
  values: string[];
}

export type BaseTagFilters = BaseTagFilterItem[];

export type TagFilters = Record<string, string[]>;

export type ISectionOption = string | { label: string; options: string[] };

// -- Migration in Progress ...

export interface IMakeModelFilters {
  [InventoryField.make]: string[];
  [InventoryField.model]: Record<string, string[]>;
}

export type IBaseFilters = Partial<Record<InventoryField, string[]>>;
